export default __webpack_public_path__ + "static/media/img-page3.31544ba5.png";